import { render, staticRenderFns } from "./ResetPIN.vue?vue&type=template&id=13fc968e"
import script from "./ResetPIN.vue?vue&type=script&lang=ts"
export * from "./ResetPIN.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports